import { useContext, useState, useEffect } from "react";
import { ThemeContext, PreferredLanguageContext } from "../../lib/main-context";

import Logo from "../../images/Logo.png";
import LogoWhite from "../../images/LogoWhite.png";
import Form from "react-bootstrap/Form";

const Brand = () => {
  const [isChecked, setIsChecked] = useState(false);
  const { dark } = useContext(ThemeContext);
  const { language, updateLanguage } = useContext(PreferredLanguageContext);

  useEffect(() => {
    setIsChecked(language === "spanish");
  }, [language]);

  const handleChange = () => {
    const newLanguage = isChecked ? "english" : "spanish";
    updateLanguage(newLanguage);
    setIsChecked(!isChecked);
  };

  return (
    <div className="flex flex-col items-center gap-2 mt-4 mb-2 md:flex-row md:justify-between md:mx-5">
      <img
        src={dark ? LogoWhite : Logo}
        className="w-60 h-auto md:w-75"
        alt="Power of Patients brand-img"
      />
      <Form>
        <Form.Check
          type="switch"
          id="custom-switch"
          label={isChecked ? "Switch to English?" : "¿Cambiar al español?"}
          checked={isChecked}
          onChange={handleChange}
        />
      </Form>
    </div>
  );
};

export default Brand;
